import { Resgate3D } from './viaturas/Resgate3D'

/** Viatura de resgate na mesa (ver `Resgate3D`). */
export function ResgateTabletop({ cor = '#dc2626' }: { cor?: string }) {
  return <Resgate3D cor={cor} />
}
